import React from "react";
import { FaHome, FaClipboardCheck, FaPencilAlt, FaMousePointer } from "react-icons/fa";

const StepsSection = () => {
  return (
    <section className="steps-section">
      <div className="container text-center">
        <h2 className="steps-title">Get your estimate in 4 simple steps</h2>
        <p className="steps-subtitle">It's that simple and convenient!</p>
        <div className="row mt-5">
          <div className="col-md-3">
            <div className="step-item">
              <div className="icon-circle">
                <FaHome className="step-icon" />
              </div>
              <h5 className="step-title">Choose your BHK type</h5>
              <p className="step-desc">
                The type of house helps us understand the configuration of your home.
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="step-item">
              <div className="icon-circle">
                <FaClipboardCheck className="step-icon" />
              </div>
              <h5 className="step-title">Select the size of your house</h5>
              <p className="step-desc">
                This will help us give you a more accurate estimate for your interiors.
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="step-item">
              <div className="icon-circle">
                <FaPencilAlt className="step-icon" />
              </div>
              <h5 className="step-title">Pick the rooms to be designed</h5>
              <p className="step-desc">
                This will help us understand the scope of work for your home interiors.
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="step-item">
              <div className="icon-circle">
                <FaMousePointer className="step-icon" />
              </div>
              <h5 className="step-title">Pick a package as per your preference</h5>
              <p className="step-desc">
                This helps us fine tune the calculation based on the products and accessories that match your lifestyle.
              </p>
            </div>
          </div>
        </div>
        <button className="btn  mt-4">GET FREE ESTIMATE</button>
      </div>
    </section>
  );
};

export default StepsSection;
